function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { REMEMBER_REHYDRATED } from "./action-types.js";
import { pick } from "./utils.js";
export var loadAll = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (_ref) {
    var rememberedKeys = _ref.rememberedKeys,
      driver = _ref.driver,
      prefix = _ref.prefix,
      unserialize = _ref.unserialize;
    var data = yield driver.getItem("".concat(prefix, "rootState"));
    if (data === null || data === undefined) {
      return {};
    }
    return pick(unserialize(data, 'rootState'), rememberedKeys);
  });
  return function loadAll(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var loadAllKeyed = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(function* (_ref3) {
    var rememberedKeys = _ref3.rememberedKeys,
      driver = _ref3.driver,
      prefix = _ref3.prefix,
      unserialize = _ref3.unserialize;
    var items = yield Promise.all(rememberedKeys.map(function (key) {
      return driver.getItem("".concat(prefix).concat(key));
    }));
    return rememberedKeys.reduce(function (obj, key, i) {
      if (items[i] !== null && items[i] !== undefined) {
        obj[key] = unserialize(items[i], key);
      }
      return obj;
    }, {});
  });
  return function loadAllKeyed(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
export var rehydrate = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(function* (store, rememberedKeys, _ref5) {
    var prefix = _ref5.prefix,
      driver = _ref5.driver,
      persistWholeStore = _ref5.persistWholeStore,
      unserialize = _ref5.unserialize;
    var state = {};
    try {
      var load = persistWholeStore ? loadAll : loadAllKeyed;
      state = yield load({
        rememberedKeys: rememberedKeys,
        driver: driver,
        prefix: prefix,
        unserialize: unserialize
      });
    } catch (err) {
      console.warn('redux-remember: rehydrate error', err);
    }
    store.dispatch({
      type: REMEMBER_REHYDRATED,
      payload: state
    });
  });
  return function rehydrate(_x3, _x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}();
//# sourceMappingURL=rehydrate.js.map